import React, { useEffect, useState } from 'react';
import { useObserver } from "mobx-react";
import { Card, CardContent, Dialog, Typography } from '@material-ui/core';
import { RequestStatus, stores } from 'mobx-store';

import { UserPasswordProps } from './types';
import Spinner from 'components/Spinner';


const UserPasswordModal: React.FC<UserPasswordProps> = (props: UserPasswordProps) => {

    const {
        authStore
    } = stores;
    const {
        handleClose,
        modalOpen,
    } = props;

    useEffect(() => {
        if (props.modalOpen)
            authStore.getUserOtPassword(+props.userId!);
    }, [props.modalOpen])

    return useObserver(() => (
        <Dialog
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth
        >
            <Card>
                <CardContent>
                    {authStore.passwordLoadingState === RequestStatus.LOADING ? <Spinner /> : <Typography>The temp password is: {authStore.otPassword}</Typography>}

                </CardContent>

            </Card>
        </Dialog>
    ));
}
export default UserPasswordModal;